import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { useAddResearcherId } from '../model/DashboardQuery';
import { WosResearcherIdRequest } from '../model/DashboardTypes';
import { ResearcherIdAddForm } from './ResearcherIdAddForm';

export function ResearcherIdAddButton() {
  const { mutate, isPending } = useAddResearcherId();
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const notification = useAppNotification();

  const handleChange = (request: WosResearcherIdRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        size="xs"
        variant="outline"
        loading={isPending}
        onClick={open}
      >
        {t('wos.addResearcherId')}
      </Button>
      {opened && (
        <ResearcherIdAddForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
        />
      )}
    </>
  );
}
